module.exports = __webpack_public_path__ + "static/media/locale-selection-button-icon.cb23862a.svg";